module.exports = __webpack_public_path__ + "img/bth_bed_right_beibu_sel.47facc10.png";